import * as React from 'react'
import FormGroup from './form-group'
import InputLabel from './input-label'
import Description from './description'
import Errors from './errors'
import './checkbox-input.css'


export default class CheckboxInput extends React.Component<any, any>{
    
    onChange(e){
        this.props.updateField(this.props.field, e.target.checked)
    }


    render(){
        const props = this.props;
        const field = props.field;
        const label = props.label;
        const errors = props.errors;
        const value = props.value;
        const updateField = props.updateField;
        const show = props.show;

        return (
            <div className="checkbox-input col-12">
                <FormGroup className="form-group-check" field={ field } errors={ errors }>
                { value }
                    <label className="form-check-label" >
                        <label className="custom-control custom-checkbox">
                            <input
                                id = { field }
                                name = { field }
                                className = "form-check-input custom-control-input"
                                onChange = { this.onChange.bind(this) }
                                checked = { value }
                                type="checkbox"            
                            />
                            <span className={"custom-control-indicator" + (value ? " custom-control-indicator-checked" : "")}></span>
                            <span className="custom-control-description">{ label }</span>
                        </label>
                    </label>
                    <Errors errors={ errors } />
                </FormGroup>
            </div>
        )
    }

}





// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/components/checkbox-input.tsx